import _ from "lodash";
import client from "lib/apolloClient/client";

import { getNotificationsV2Query } from "./NotificationCenterV2Queries";
import {
  notificationListNodeV2Fragment,
  notificationItemV2Fragment,
} from "./NotificationCenterV2Fragments";

const userNotificationListFragmentMapV2 = {
  STAFF: {
    typeName: "Staff",
    fragment: notificationListNodeV2Fragment["staff"],
    fragmentName: "staffItem",
  },
  STUDENT: {
    typeName: "Student",
    fragment: notificationListNodeV2Fragment["student"],
    fragmentName: "studentItem",
  },
  FAMILY_MEMBER: {
    typeName: "FamilyMember",
    fragment: notificationListNodeV2Fragment["parent"],
    fragmentName: "parentItem",
  },
};

export const getNotificationListV2FromCache = ({
  id,
  type,
  filters,
  notificationCategoryFilter,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getNotificationsV2Query,
      variables: {
        id,
        type,
        filters,
        notificationCategoryFilter,
      },
    });
  } catch (e) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const writeNotificationListV2InCache = ({
  id,
  type,
  data,
  filters,
  notificationCategoryFilter,
}) => {
  const {
    typeName,
    fragment,
    fragmentName,
  } = userNotificationListFragmentMapV2[type];

  try {
    client.writeFragment({
      id: `${typeName}:${id}`,
      fragment,
      fragmentName,
      variables: {
        filters,
        notificationCategoryFilter,
      },
      data,
    });
  } catch (e) {
    return {};
  }
};

export const getNotificationV2FromCache = notificationId => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `Notification:${notificationId}`,
      fragment: notificationItemV2Fragment.notificationItem,
      fragmentName: "notificationItem",
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const writeNotificationV2Fragment = ({ notificationId, data }) => {
  try {
    client.writeFragment({
      id: `Notification:${notificationId}`,
      fragment: notificationItemV2Fragment.notificationItem,
      fragmentName: "notificationItem",
      data,
    });
  } catch (e) {}
};
